import { useEffect, useState } from "react";
import AdLayout from "../components/AdLayout";
import axiosInstance from "../axiosInstance";
import { canViewAccountingReports } from "../libs/customerCreatePermission";
import { FinancialDashboardBody } from "./accounting/FinancialDashboard";

const AdminWelcome = () => {
  const [access, setAccess] = useState({ loaded: false, canViewReports: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const canView = await canViewAccountingReports(axiosInstance);
      if (!cancelled) {
        setAccess({ loaded: true, canViewReports: canView });
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <AdLayout roles={["admin", "member"]}>
      {access.loaded && access.canViewReports && <FinancialDashboardBody embedded />}
    </AdLayout>
  );
};

export default AdminWelcome;
